import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { AccountFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkAccountPOSTErrorResponse, ParkAccountPOSTRequest, ParkAccountPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const fetchAccount = async (requestData: ParkAccountPOSTRequest): Promise<ParkAccountPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkAccountPOSTSuccessResponse>("/account", requestData);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkAccountPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: AccountFailReason.SystemError };
  }
};
